import { CollectionPaymentTypes, PayablePaymentStatusEnum, RMTypePaybleEnum, TransactionPaymentType, TransactionStatus } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { CollectionsEntity } from "./collections.entity";

@Entity('payables')
export class PayableEntity{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;
 
@Column({
    type:"varchar",
    nullable: true,
    name: "invoice_type"
  })
  invoiceType: string; 
 
  @Column({
    type:"int",
    nullable: true,
    name: "invoice_id"
  })
  invoiceId: number; 

@Column({
    type:"enum",
    enum:PayablePaymentStatusEnum,
    nullable: true,
    name: "status"
  })
  status: PayablePaymentStatusEnum; 

  @Column({
    type:"varchar",
    length:50,
    nullable: true,
    name: "invoice_number"
  })
  invoiceNum: string; 
  
   @Column({
    type:"int",
    nullable: true,
    name: "vendor_id"
  })
  vendorId: number;
  @Column({
    type:"date",
    nullable: true,
    name: "received_date"
  })
  receivedDate: Date; 

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "quantity"
  })
  quantity: number; 

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "amount"
  })
  amount: number; 

   @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "deduction"
  })
  deduction: number;

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "final_amount"
  })
  finalAmount: number;
    @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "payment"
  })
  payment: number; 

    @Column("boolean", {
    default: true,
    name: "tds_applicable"
  })
  tdsApplicable: boolean;

  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

   @Column({
    type:"date",
    nullable: true,
    name: "invoice_date"
  })
  invoiceDate: Date; 

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @Column({
    type:"enum",
    enum:RMTypePaybleEnum,
    nullable: true,
    name: "rm_type"
  })
  rmType: RMTypePaybleEnum; 

    @Column({
    type:"int",
    nullable: true,
    name: "tax_id"
  })
  taxId: number; 

     @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "duty_per"
  })
  dutyPercentage: number;

    

  @Column({
    type: "int",
    nullable: true,
    name: "currency"
  })
  currency: number;

  @Column({
    type: "decimal",
    precision: 10,
    scale: 2,
    nullable: true,
    name: "exchange_rate"
  })
  exchangeRate: number;

  @Column({
    type: "decimal",
    precision: 10,
    scale: 2,
    nullable: true,
    name: "received_amount_inr"
  })
  receivedAmountInr: number;

  @Column({
    type: "int",
    nullable: true,
    name: "bank_account"
  })
  bankAccount: number;

  @Column({
    type: "decimal",
    precision: 10,
    scale: 2,
    nullable: true,
    name: "bank_charges"
  })
  bankCharges: number;

  @Column({
    type: "decimal",
    precision: 10,
    scale: 2,
    nullable: true,
    name: "buyer_short_payment"
  })
  buyerShortPayment: number;

    @Column({
    type:"varchar",
    length:50,
    nullable: true,
    name: "remarks"
  })
  remarks: string; 
;
}